import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdValidDatesDetection } from 'dashboard/models/check';
import { COUNTRIES, US_STATES } from 'lib/constants/locales';

export const computeIdValidDatesDetectionMetadata = (
  check: IdValidDatesDetection,
): CheckMetadata => {
  const { 'issuing-country': issuingCountry, 'issuing-subdivision': issuingSubdivision } =
    check.metadata || {};
  const metadata = check.reasons?.includes('issuer_rules_inconsistency')
    ? [
        {
          label: 'ID Expiration Date Anomaly',
          // Before Aug 2024, check only supported US and metadata only contained subdivision
          value: `The validity of the ID does not appear to conform to rules set by ${(issuingCountry && issuingCountry !== 'US') || issuingSubdivision == null ? (issuingCountry ? COUNTRIES[issuingCountry] : '') : US_STATES[issuingSubdivision]}.`,
        },
      ]
    : [];
  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
